module.exports = __webpack_public_path__ + "img/add_btn_icon460.a0b1cd78.svg";